<template>
    <footer>
        <p>German Gamboa &copy; 2018</p>
    </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    footer {
        margin-top: 2em;
        padding: .3em 0;
        position: relative;
        z-index: 1;
        background-color: #253644;
    }
    p {
        margin: 0 auto;
        color: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue